import React from 'react';
import DateFormat from "./DateFormat";

class InterventionDate extends React.Component {

  render() {
    const {interventionStart, interventionEnd, properties:{reception:{dropOff={}, pickUp={}}={}}={}} = this.props;

    const startDateLayout = dropOff.duringWorkingHours === false ? "dateOnlyShort" : "dateTimeShort";
    const endDateLayout = pickUp.duringWorkingHours === false ? "dateOnlyShort" : "dateTimeShort";
    return (
      <span>
        {interventionStart &&
          <span>
            <svg className="bmw-icon bmw-icon-sm"><use xlinkHref="#icon-arrow-circle-right"/></svg>
            <DateFormat className="ml-1" layout={startDateLayout} date={interventionStart}/>
            <br/>
          </span>
        }
        {interventionEnd &&
          <span>
            <svg className="bmw-icon bmw-icon-sm"><use xlinkHref="#icon-arrow-circle-left"/></svg>
            <DateFormat className="ml-1" layout={endDateLayout} date={interventionEnd}/>
          </span>
        }
      </span>
    )
  }

}

export default InterventionDate;



// WEBPACK FOOTER //
// ./src/components/common/format/InterventionDate.js